export default theme => ({
  root: {
    padding: theme.spacing(3)
  },
});
